/**
 * antd 样式前缀
 */
export const antdPrefixCls = 'cashier-counter';
